import { ApiSchoolsService } from './../../../../../service/api-schools.service';
import { SearchByComponent } from './../../../../school/search-by-layer/search-by-layer.component';
import { MsinMatTableComponent } from './../../../../school/msin-mat-table/msin-mat-table.component';
import { SearchLocationLayerComponent } from './../../../../school/search-location-layer/search-location-layer.component';
import { ProvisionalSchoolsService } from './../../../service/provisional-schools.service';
import { Component, ElementRef, Inject, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Student } from 'src/app/model/student/student.model';
import Swal from 'sweetalert2';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { CountyDropdownTwoWayComponent } from 'src/app/component/common-components/county/county-dropdown-two-way/county-dropdown-two-way.component';
import { DistrictComponent } from 'src/app/component/common-components/district/district.component';
import { RegionDropdownTwoWayComponent } from 'src/app/component/common-components/region/region-dropdown-two-way/region-dropdown-two-way.component';
import { Region } from 'src/app/model/region.model';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { School } from 'src/app/model/school.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { ActivatedRoute, ParamMap } from '@angular/router';

@Component({
    selector: 'app-resolve-provisional-school-modal',
    templateUrl: './resolve-provisional-school-modal.component.html',
    styleUrl: './resolve-provisional-school-modal.component.scss'
})
export class ResolveProvisionalSchoolModalComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    @ViewChild('resolveTo') resolveToElement: ElementRef;
    @ViewChild('res') resElement: ElementRef;

    @ViewChild(MsinMatTableComponent) child!: MsinMatTableComponent;
    @ViewChild(SearchByComponent) child2!: SearchByComponent;
    @ViewChild(DistrictComponent) child3!: DistrictComponent;
    @ViewChild(RegionDropdownTwoWayComponent) child4!: RegionDropdownTwoWayComponent;
    @ViewChild(CountyDropdownTwoWayComponent) child5!: CountyDropdownTwoWayComponent;
    @ViewChild(SearchLocationLayerComponent) child6!: SearchLocationLayerComponent;

    @Input() students!: Student[];
    @Input() provisionalSchoolInput: any;

    searchForm: FormGroup;

    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];

    provisionalSchool: any;
    chosenSchool: any;

    editingProvisionalSchoolInformation: boolean = false;

    // Table results
    tableDataSources: MatTableDataSource<School>[] = [];
    results: School[] = [];
    filter: string = '';
    schoolLength: number;

    // Table display
    columns = {
        EDIT: { INDEX: 1, ENABLED: true, SORT: 'EDIT', DATA: 'EDIT', DISABLED: false },

        Region: { INDEX: 2, ENABLED: true, SORT: 'REGIONS.CODE', DATA: 'REGIONS.CODE', DISABLED: false },

        County: { INDEX: 3, ENABLED: true, SORT: 'COUNTy.COUNTY_NAME', DATA: 'COUNTy.COUNTY_NAME', DISABLED: false },
        District: { INDEX: 4, ENABLED: true, SORT: 'SCHOOL_DISTRICT.DISTRICTS', DATA: 'SCHOOL_DISTRICT.DISTRICTS', DISABLED: false },

        'School Name': { INDEX: 5, ENABLED: true, SORT: 'NAME', DATA: 'NAME', DISABLED: false },

        Address: {
            INDEX: 6,
            ENABLED: true,
            SORT: 'ORGANIZATION.PARTy.PARTY_CONTACT_MECHANISMS[0].CONTACT_MECHANISMS.POSTAL_ADDRESSES[0].STREET_1',
            DATA: 'ORGANIZATION.PARTy.PARTY_CONTACT_MECHANISMS[0].CONTACT_MECHANISMS.POSTAL_ADDRESSES[0].STREET_1',
            DISABLED: false
        },
        Phone: {
            INDEX: 7,
            ENABLED: true,
            SORT: 'ORGANIZATION.PARTy.PARTY_CONTACT_MECHANISMS[0].CONTACT_MECHANISMS.TELEPHONE_NUMBERS[0].PHONE_NUMBER',
            DATA: 'ORGANIZATION.PARTy.PARTY_CONTACT_MECHANISMS[0].CONTACT_MECHANISMS.TELEPHONE_NUMBERS[0].PHONE_NUMBER',
            DISABLED: false
        },

        'CDS Code': { INDEX: 8, ENABLED: true, SORT: 'cdscODE', DATA: 'cdscODE', DISABLED: false }
    };
    selectedColumns: string[] = [];

    baseDisplayedColumns: string[] = [];
    suffixColumns: string[] = [];
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    isLoading: boolean = false;
    isSearching: boolean = false;
    isResolving: boolean = false;
    resetField: boolean = false;
    loadingSchool: any = {};

    getPropertyPipe = new GetPropertyPipe();

    msg: MsgModel | undefined;
    searchSchoolMsg: MsgModel | undefined;
    resolveMsg: MsgModel | undefined;

    constructor(
        public dialogRef: MatDialogRef<ResolveProvisionalSchoolModalComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private provisionalSchoolsService: ProvisionalSchoolsService,
        private fb: FormBuilder,
        private schoolService: ApiSchoolsService
    ) {
        this.searchForm = this.fb.group({
            schoolName: [''],
            schoolAddress: [''],
            schoolCity: [''],
            cdsCode1: [''],
            cdsCode2: [''],
            cdsCode3: ['']
        });
    }

    ngOnInit(): void {
        this.isLoading = true;

        // Use data
        if (this.data) {
            this.students = this.data.students;
            this.provisionalSchoolInput = this.data.provisionalSchoolEnrollment;

            this.showProvisionalSchool();
        } else {
        }

        // Display columns
        let prefixColumns: string[] = [];
        this.displayedColumns = this.generateDisplayColumns(prefixColumns);

        this.isLoading = false;
    }

    showProvisionalSchool() {
        if (this.provisionalSchoolInput.PROVISIONAL_SCHOOLS_ID) {
            this.provisionalSchoolsService.show(this.provisionalSchoolInput.PROVISIONAL_SCHOOLS_ID).subscribe((res) => {
                if (res?.provisionalSchool) {
                    this.provisionalSchool = res.provisionalSchool;
                } else if (res?.msg) {
                    this.msg = res.msg;
                } else {
                    this.msg = new MsgModel();
                    this.msg.MSG = 'Error retrieving provisional school.';
                    this.msg.SUCCESS = false;
                }
            });
        }
    }

    /*
		Resolve functions
	*/
    resolveProvisionalSchool() {
        if (this.chosenSchool && this.provisionalSchool) {
            this.isResolving = true;
            this.resolveMsg = undefined;

            this.provisionalSchoolsService.resolveProvisionalSchool(this.provisionalSchool, this.chosenSchool).subscribe({
                next: (res) => {
                    if (res.msg) {
                        this.resolveMsg = res.msg;
                    } else {
                        this.resolveMsg = { SUCCESS: false, MSG: 'Error resolving provisional school.' };
                    }
                },
                error: (err) => {
                    this.resolveMsg = { SUCCESS: false, MSG: 'Error resolving provisional school.' };
                },
                complete: () => {
                    if (this.resolveMsg && this.resolveMsg.SUCCESS) {
                        this.resolveMsg.MSG += ' Closing model in 3 seconds...';
                        setTimeout(() => {
                            this.dialogRef.close();
                        }, 3000);
                    } else {
                        this.isResolving = false;
                    }
                }
            });
        }
    }

    /*
		Search School functions
	*/
    checkValid(): boolean {
        const { schoolName, schoolAddress, schoolCity, cdsCode1, cdsCode2, cdsCode3 } = this.searchForm.value;

        return (
            [schoolName, schoolAddress, schoolCity, cdsCode1, cdsCode2, cdsCode3].some((value) => value?.trim().length > 0) ||
            this.chosenRegions.length > 0 ||
            this.chosenCounties.length > 0 ||
            this.chosenSchoolDistricts.length > 0
        );
    }

    refreshSchool(schoolId: number): void {
        if (schoolId) {
            this.loadingSchool[schoolId.toString()] = true;

            this.schoolService.show(schoolId).subscribe({
                next: (res) => {
                    if (res.school) {
                        this.chosenSchool = res.school;
                    } else if (res.msg) {
                        this.chosenSchool = undefined;
                        this.searchSchoolMsg = res.msg;
                    } else {
                        this.chosenSchool = undefined;
                        this.searchSchoolMsg = { SUCCESS: false, MSG: 'Error retrieving selected school.' };
                    }
                },
                error: (err) => {
                    this.chosenSchool = undefined;
                    this.searchSchoolMsg = { SUCCESS: false, MSG: 'Error retrieving selected school.' };
                },
                complete: () => {
                    if (this.chosenSchool) {
                        setTimeout(() => {
                            const targetElement = this.resolveToElement.nativeElement;
                            targetElement.scrollIntoView({ behavior: 'smooth' });
                        }, 100);
                    }
                    this.loadingSchool[schoolId.toString()] = false;
                }
            });
        }
    }

    searchSchool(): void {
        if (this.checkValid()) {
            this.isSearching = true;
            this.searchSchoolMsg = undefined;
            this.filter = '';

            this.schoolService.getAllSchools(this.buildSearchSchoolPayload()).subscribe({
                next: (res) => {
                    if (res.schools) {
                        this.results = res.schools.sort((n1: School, n2: School) => (n1.NAME! > n2.NAME! ? 1 : -1));
                        this.schoolLength = res.schools.length;
                    } else if (res.msg) {
                        this.results = [];
                        this.searchSchoolMsg = res.msg;
                    } else {
                        this.results = [];
                        this.searchSchoolMsg = { SUCCESS: false, MSG: 'Error searching schools.' };
                    }
                },
                error: (err) => {
                    this.results = [];
                    this.searchSchoolMsg = { SUCCESS: false, MSG: 'Error searching schools.' };
                },
                complete: () => {
                    // Updates the Tables to be displayed w/ this.results
                    if (this.results.length > 0) {
                        this.updateDataSource(true);
                    }

                    // Display results
                    this.isSearching = false;

                    setTimeout(() => {
                        const targetElement = this.resElement.nativeElement;
                        targetElement.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            });
        }
    }

    buildSearchSchoolPayload() {
        let payload = {};

        const formValue = this.searchForm.value;

        payload = {
            ...formValue,
            chosenRegions: this.chosenRegions.map((region) => ({ ID: region.ID })),
            chosenCounties: this.chosenCounties.map((counties) => ({ ID: counties.ID })),
            chosenSchoolDistricts: this.chosenSchoolDistricts.map((schoolDistricts) => ({ ID: schoolDistricts.ID }))
        };

        return payload;
    }

    reset(): void {
        this.searchForm.reset();
        this.resetField = true;
    }

    generateDisplayColumns(prefixColumns?: string[]) {
        let displayedColumns: string[] = prefixColumns ? prefixColumns : [];
        let columns: any = this.columns;
        //displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

        const properties = Object.keys(columns);
        properties.forEach((property) => {
            if (columns[property].ENABLED) {
                displayedColumns.push(columns[property].SORT);
            }
        });

        return displayedColumns;
    }

    updateDataSource(newSort?: boolean) {
        setTimeout(() => {
            this.tableDataSources = [];

            // Data
            let dataSource = new MatTableDataSource<any>();
            dataSource.data = this.results;

            // Paginator
            dataSource.paginator = this.paginators.toArray()[0];

            // Sort
            dataSource.sort = this.sorts.toArray()[0];
            dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);
            if (newSort) {
                const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
                dataSource.sort.active = defaultSort.active;
                dataSource.sort.direction = defaultSort.direction;
                dataSource.sort.sortChange.emit(defaultSort);
            } else {
                dataSource.sort.sortChange.emit(this.sorts.toArray()[0]);
            }
            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.tableDataSources.push(dataSource);
        }, 100);
    }

    setFilter() {
        this.tableDataSources.forEach((dataSource, index) => {
            dataSource.filter = this.filter.trim().toLocaleLowerCase();
        });
    }

    chooseSchool(school: School) {
        if (school.ID) {
            this.refreshSchool(school.ID);
        }
    }

    reselectSchool() {
        this.chosenSchool = undefined;

        setTimeout(() => {
            const targetElement = this.resElement.nativeElement;
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    }

    // Dialog function
    closeDialog(closed: boolean) {
        Swal.fire({
            titleText: 'Are you sure you want to continue without saving?',
            showDenyButton: false,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Go Back',
            icon: 'warning',
            confirmButtonColor: '#3a6b35'
        }).then((result: any) => {
            if (result.isConfirmed) {
                this.dialogRef.close();
            }
        });
    }

    toggleEdit(state: boolean) {
        this.editingProvisionalSchoolInformation = state;
    }

    onProvisionalSchoolChange(updated: any) {
        this.provisionalSchool = updated;

        this.editingProvisionalSchoolInformation = false;
    }
}
